import { createContext } from 'react';

const SideScreen = createContext();

export default SideScreen;
